<template>
  <div>
    <slot name="banner"></slot>
    <LazyHydrate when-idle>
      <TheHeader
        :isBlueBack="$route.meta.isHeaderBlue"
        :shoppingSrc="shoppingSrc"
      />
    </LazyHydrate>
    <!-- <NuxtImg
      sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
      width="1000"
      height="1000"
      format="webp"
      class="just-desktop w-full"
      quality="100"
      src="img/banner/oelecomp1403.png"
      alt=""
    />
    <NuxtImg
      sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
      width="1000"
      height="1000"
      format="webp"
      class="just-mobile w-full"
      quality="100"
      src="img/banner/oelecomp1403-mobile.png"
      alt=""
    /> -->

    <slot></slot>

    <LazyHydrate when-visible>
      <TheFooter />
    </LazyHydrate>

    <LazyHydrate when-idle>
      <SectionModalMain />
    </LazyHydrate>

    <LazyHydrate when-idle>
      <SectionModalSuccess />
    </LazyHydrate>
  </div>
</template>

<script>
export default {
  name: "DefaultLayout",

  props: {
    shoppingSrc: {
      type: String,
      default: "/online-shopping/buy/",
    },
  },

  data() {
    return {
      isModalShowed: false,
      clipped: false,
      drawer: false,
      fixed: false,
      items: [
        {
          icon: "mdi-apps",
          title: "Welcome",
          to: "/",
        },
        {
          icon: "mdi-chart-bubble",
          title: "Inspire",
          to: "/inspire",
        },
      ],
    };
  },
};
</script>
